import { Inject, Injectable } from '@angular/core';
import { AggregateLocationViewModel } from '../../src/typings/api';
import { AppRootScope } from '../../src/typings/AppRootScope';
import { EventTypes, ILocationLoadedEventData } from '../../src/typings/models';
import { ILocationLoadedEventService } from '../../src/typings/services';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';

/**
 * Notify other application components that the selected location has been loaded
 */

@Injectable({
    providedIn: 'root'
})
export class LocationLoadedEventService implements ILocationLoadedEventService {
    public static $name = 'locationLoadedEventService';

    constructor(
        @Inject('$rootScope') private $rootScope: AppRootScope,
        private commonBroadcastService: CommonBroadcastService
    ) {
    }

    public publish(location: AggregateLocationViewModel, stateKey: string, stateParams: any) {
        this.$rootScope.publish(EventTypes.LocationLoaded, {
            location: location,
            stateKey: stateKey,
            stateParams: stateParams
        } as ILocationLoadedEventData);
        this.commonBroadcastService.broadcast(EventTypes.LocationLoaded, {
            location: location,
            stateKey: stateKey,
            stateParams: stateParams
        } as ILocationLoadedEventData);
    }

    public publishUnloaded() {
        this.publish(null, null, null);
    }
}
